import React from 'react';
// import PropTypes from 'prop-types'
import styled from 'styled-components';
import CloseIcon from '@material-ui/icons/Close';

const ChipContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 4px;
  /* height: 1.5em; */
  background: #F9F9F9;
  /* Otros / Dividers */
  border: 1px solid #EFEFEF;
  box-sizing: border-box;
  border-radius: 5px;
  align-items: center;
  cursor: auto;
`
const ImageChip = styled.img`
  height: 1.4em;
  width: auto;
  margin-right: .5em;
`
const Label = styled.span`
  font-family: OpenSansRegular;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0.005em;
  /* Textos / Principal */
  color: #333333;
`

const CustomChip = ({ label, img, onDelete }) => {
  return (
    <ChipContainer>
      {img && <ImageChip src={img} />}
      <Label>{label}</Label>
      <CloseIcon style={{color: '#FF6868', cursor: 'pointer', marginLeft: '.3em'}} onClick={onDelete}/>
    </ChipContainer>
  )
}

CustomChip.propTypes = {

}

export default CustomChip
